"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const token_parser_1 = require("../token-parser");
const token_1 = require("../token");
const import_1 = require("../node/import");
const assign_name_1 = require("../node/expression/assign-name");
/**
 * Imports macros.
 *
 * <pre>
 *   {% from 'forms.html' import forms %}
 * </pre>
 */
class TwingTokenParserFrom extends token_parser_1.TwingTokenParser {
    parse(token) {
        let macro = this.parser.getExpressionParser().parseExpression();
        let stream = this.parser.getStream();
        stream.expect(token_1.TwingToken.NAME_TYPE, 'import');
        let targets = new Map();
        do {
            let name = stream.expect(token_1.TwingToken.NAME_TYPE).getValue();
            let alias = name;
            if (stream.nextIf(token_1.TwingToken.NAME_TYPE, 'as')) {
                alias = stream.expect(token_1.TwingToken.NAME_TYPE).getValue();
            }
            targets.set(name, alias);
            if (!stream.nextIf(token_1.TwingToken.PUNCTUATION_TYPE, ',')) {
                break;
            }
        } while (true);
        stream.expect(token_1.TwingToken.BLOCK_END_TYPE);
        let node = new import_1.TwingNodeImport(macro, new assign_name_1.TwingNodeExpressionAssignName(this.parser.getVarName(), token.getLine(), token.getColumn()), token.getLine(), token.getColumn(), this.getTag());
        for (let [name, alias] of targets) {
            this.parser.addImportedSymbol('function', alias, `macro_${name}`, node.getNode('var'));
        }
        return node;
    }
    getTag() {
        return 'from';
    }
}
exports.TwingTokenParserFrom = TwingTokenParserFrom;
